<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <h1 class="display-1 text-white">
                  Portfolio - Seattle
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-4 order-md-1">
            <div class="pr-md-5"></div>
          </div>
          <div class="col-md-12 order-md-2">
            <div class="pr-md-5">
              <h3>
                <icon name="ni ni-like-2" class="mb-5" size="lg" type="primary" shadow rounded></icon>
                We spent the summer of 2024 together here!
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden" id="olympic-national-park">
      <div class="shape shape-style-1 bg-gradient-primary shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-lg-7 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-calendar-grid-58" size="lg" class="bg-gradient-white" color="primary" shadow rounded>
                </icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Olympic National Park</h4>
                <h5 class="text-white">2024/08</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="container py-0">
          <div class="row row-grid align-items-center">
            <div class="col-md-7">
              <card shadow class="shadow-lg--hover mt-5">
                <div class="d-flex px-3">
                  <div class="pl-4">
                    <h5 class="title text-primary">This is a fantastic national park. </h5>
                    <h5 class="title text-primary">We spent 2 days driving in the park.</h5>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row" id="olympic-game-farm">
          <div class="pr-md-5">
            <icon name="ni ni-square-pin" class="mb-5" size="lg" type="primary" shadow rounded></icon>
            <h3 class="display-3">Olympic Game Farm</h3>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-istanbul"></badge>
                  <h6 class="mb-0">Many animals!!</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-3 order-md-1">
              <img src="img/seattle/olympic_national_park/olympic_game_farm/1.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-2">
              <img src="img/seattle/olympic_national_park/olympic_game_farm/3.png" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-3">
              <img src="img/seattle/olympic_national_park/olympic_game_farm/2.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-4">
              <img src="img/seattle/olympic_national_park/olympic_game_farm/4.png" class="img-fluid floating" />
          </div>
        </div>
        <div class="row" id="lake-cresent">
          <div class="pr-md-5">
            <icon name="ni ni-square-pin" class="mb-5" size="lg" type="primary" shadow rounded></icon>
            <h3 class="display-3">Lake Cresent</h3>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-sound-wave"></badge>
                  <h6 class="mb-0">Dive into cold and deep water!</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-3 order-md-1">
              <img src="img/seattle/olympic_national_park/lake_cresent/1.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-2">
              <img src="img/seattle/olympic_national_park/lake_cresent/2.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-3">
              <img src="img/seattle/olympic_national_park/lake_cresent/3.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3 order-md-4">
              <img src="img/seattle/olympic_national_park/lake_cresent/4.jpg" class="img-fluid floating" />
          </div>
        </div>
        <div class="row row-grid align-items-center" id="hoh-rain-forest">
          <div class="col-md-1"></div>
          <div class="col-md-4">
              <img src="img/seattle/olympic_national_park/hoh_rain_forest/1.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <icon name="ni ni-square-pin" class="mb-5" size="lg" type="primary" shadow rounded></icon>
            <h3 class="display-3">Hoh Rain Forest</h3>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-favourite-28"></badge>
                  <h6 class="mb-0">We saw a deer! Only we saw!!</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-1"></div>
          <div class="col-md-3">
              <img src="img/seattle/olympic_national_park/hoh_rain_forest/2.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3">
              <img src="img/seattle/olympic_national_park/hoh_rain_forest/3.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-3">
              <img src="img/seattle/olympic_national_park/hoh_rain_forest/4.jpg" class="img-fluid floating" />
          </div>
        </div>
        <div class="row row-grid align-items-center" id="la-push">
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <icon name="ni ni-square-pin" class="mb-5" size="lg" type="primary" shadow rounded></icon>
            <h3 class="display-3">La Push</h3>
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-favourite-28"></badge>
                  <h6 class="mb-0">The most romantic place in the park.</h6>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-5">
              <img src="img/seattle/olympic_national_park/la_push/1.jpg" class="img-fluid floating" />
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-1"></div>
          <div class="col-md-5">
              <img src="img/seattle/olympic_national_park/la_push/2.jpg" class="img-fluid floating" />
          </div>
          <div class="col-md-5">
              <img src="img/seattle/olympic_national_park/la_push/3.jpg" class="img-fluid floating" />
          </div>
        </div>
      </div>
    </section>
    <section class="section section section-shaped my-0 overflow-hidden" id="mount-rainier">
      <div class="shape shape-style-1 bg-gradient-primary shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-lg-7 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon name="ni ni-calendar-grid-58" size="lg" class="bg-gradient-white" color="primary" shadow rounded>
                </icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Mount Rainier National Park</h4>
                <h5 class="text-white">2024/08</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-grid align-items-center">
          <div class="col-md-7">
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div class="pl-4">
                  <h5 class="title text-primary">We met <b>Toposol</b>, another fantastic animal in our Goolu World.</h5>
                  <h5 class="title text-primary"><b>Toposol</b>s got their name from their digging skill that creates amazing mazes like a topologic solution.</h5>
                </div>
              </div>
            </card>
          </div>
          <div class="col-md-5">
            <div class="col-lg-10 mb-lg-auto">
              <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                <img src="img/seattle/mount_rainier/we.jpg" class="img-fluid" />
                <!-- <b-carousel id="carousel1" :interval=1000 controls indicators>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/we.jpg"></b-carousel-slide>
                </b-carousel> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-5">
            <div class="col-lg-10 mb-lg-auto">
              <div class="rounded shadow-lg overflow-hidden transform-perspective-left">
                <b-carousel id="carousel1" :interval=1000 controls indicators>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/1.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/2.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/3.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/4.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/5.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/6.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/7.jpg"></b-carousel-slide>
                </b-carousel>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <ul class="list-unstyled mt-5">
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-world"></badge>
                  <h5 class="mb-0">Mount Rainier</h5>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-atom"></badge>
                  <h5 class="mb-0">Toposol</h5>
                </div>
              </li>
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <badge type="primary" circle class="mr-3" icon="ni ni-atom"></badge>
                  <h5 class="mb-0">Squirrel</h5>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-5">
            <div class="col-lg-10 mb-lg-auto">
              <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                <b-carousel id="carousel1" :interval=1000 controls indicators>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/animal1.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/animal2.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/animal3.jpg"></b-carousel-slide>
                  <b-carousel-slide img-src="img/seattle/mount_rainier/animal4.jpg"></b-carousel-slide>
                </b-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-2"></div>
          <div class="col-md-4">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="squirrel1Options"></video-player>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-3 text-center">
              <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="squirrel2Options"></video-player>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import VideoModal from "@/components/VideoModal.vue"
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import {
    videoPlayer
} from 'vue-video-player'
import {
  BCarousel
} from "bootstrap-vue/esm/components/carousel/carousel";
import {
  BCarouselSlide
} from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  name: "seattle",
  components: {
    Modal,
    BCarousel,
    BCarouselSlide,
    VideoModal,
    videoPlayer
  },
  data() {
    return {
      modal: false,
      defaultPlayerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // play speed
        autoplay: true, // play when your browser is ready
        muted: true, // whether to mute by default
        loop: true, // restart when it ends
        preload: 'auto', // whether to download when parsing <video>
        language: 'zh-CN',
        aspectRatio: '16:9', // proportion
        fluid: true, // suit container in proportion
        sources: [{
          type: "video/mp4", // see github for more types
          src: this.video_src // url of the video
        }],
        poster: this.poster_src, // cover of the video
        // width: document.documentElement.clientWidth, // width of the player
        notSupportedMessage: 'Something went wrong', // default message when the video cannot be played
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      }
    };
  },
  computed: {
      totalTime() {
          return Math.round((new Date() - new Date(2023, 7, 24, 0, 0, 0, 0))/1000/60/60/24/365);
      },
      squirrel1Options() {
          return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/seattle/mount_rainier/squirrel1.mp4"}], aspectRatio: '9:16'}};
      },
      squirrel2Options() {
          return {...this.defaultPlayerOptions, ...{sources: [{type: "video/mp4", src: "img/seattle/mount_rainier/squirrel2.mp4"}], aspectRatio: '9:16'}};
      },
  }
};
</script>
